<template>
    <div>
        <template>
            <v-container>
                <v-row class="mt-4">
                    <v-col v-for="(card, i) in cards" :key="i" cols="12" sm="6" lg="3" xl="2" class="text-center">
                        <v-card>
                            <v-img :src="url_prefix + card.image"></v-img>
                            <v-card-text>
                                <v-row align="center" class="d-flex flex-row justify-center">
                                    <v-text-field
                                    v-model="card.price"
                                    label="価格を入力"
                                    class="mt-2 ml-4 mr-4"
                                    ></v-text-field>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-btn color="primary" elevation="2" @click="goMakePurchasePdf()" min-width="180">買取表を作成</v-btn>
        </template>
    </div>
</template>


<script>
export default {
    data: () => ({
        cards: [],
        url_prefix: "",
    }),
    methods: {
        goMakePurchasePdf() {
            // const route = this.$router.resolve({
            //     name: 'MakePurchasePdf',
            //     params: {
            //         choiced_cards: this.choiced_cards,
            //     }
            // })
            // window.open(route.href, '_blank');

            this.$router.push({
                name: 'MakePurchasePdf',
                params: {
                    choiced_cards: this.cards,
                }
            })
        }
    },
    mounted: function () {
        this.url_prefix = `${process.env.VUE_APP_API_ORIGIN}`
        this.cards = this.$route.params.choiced_cards
    },
}
</script>
